<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :id="`${name || 'checkbox'}-${uid}`"
      :name="name"
      :class="{ error: invalid }"
      v-model="ivalue"
    />
    <label :for="`${name || 'checkbox'}-${uid}`" v-html="label"></label>
  </div>
</template>

<script>
  let iid = 0;

  export default {
    name: 'Checkbox',
    components: {},
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      name: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      validator: {
        type: [RegExp, Function],
        default: null,
      },
      value: {
        type: Boolean,
        default: false,
      },
      noTracking: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      iid += 1;
      return {
        uid: iid,
        ivalue: this.value || null,
        invalid: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      ivalue(val) {
        this.validate(val);
        this.$emit('update:value', val);
        this.$emit('input', val);
      },
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      validate(val = null) {
        const value = val || this.ivalue;
        const validator = this.validator;
        const ref = this.$vnode.data.ref;
        const noTracking = this.noTracking;

        if (validator) {
          if (validator.constructor === RegExp && (value === null || !validator.test(value))) {
            this.invalid = true;
            if (!noTracking) {
              this.$b.analytics.trackFormField(ref, !this.invalid, value);
            }
            return false;
          }
          if (validator.constructor === Function && (value === null || !validator(value))) {
            this.invalid = true;
            if (!noTracking) {
              this.$b.analytics.trackFormField(ref, !this.invalid, value);
            }
            return false;
          }
        }
        this.invalid = false;
        if (!noTracking) {
          this.$b.analytics.trackFormField(ref, !this.invalid, value);
        }
        return true;
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .checkbox {
    input[type=checkbox] {
      position: absolute;
      z-index: -1;
      opacity: 0;

      &.error + label {
        &:before {
          border-color: $color-error;
        }
      }

      & + label {
        position: relative;
        display: inline-block;
        -webkit-tap-highlight-color: transparent;
        @include font-daimler-cs(400);
        font-size: inherit;
        color: $color-white;
        padding-left: 30px;
        cursor: pointer;
        user-select: none;
      }

      /* Box */
      & + label:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        border-width: 1px;
        border-style: solid;
        border-color: $color-white;
        background-color: transparent;
        transition: border-color $default-transition;
      }

      /* Checkmark */
      & + label:after {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        border-radius: 100%;
        background: $color-blue;
        width: 20px;
        height: 20px;
        transform: scale(0);
        transition: transform $default-transition;
      }

      &:focus + label:before, &:checked + label:before {
        border-color: $color-blue;
      }

      &:checked + label:after {
        transform: scale(1);
      }
    }
  }
</style>
